import { ArrowLeft, ArrowRight } from "lucide-react";
import { PlansShowcase } from "../../shared/PlansShowcase";

const CONTACT_EMAIL = "hello@cowboys.so";

type Props = {
  orgId: string;
  orgName: string;
  email: string;
  currentTierSlug: string | null;
  onContinue: () => void;
  onBack: () => void;
};

export function StepPlans({
  orgId,
  orgName,
  email,
  currentTierSlug,
  onContinue,
  onBack,
}: Props) {
  const subject = encodeURIComponent(
    `[Cowboy] Activar plan${orgName ? ` — ${orgName}` : ""}`,
  );
  const body = encodeURIComponent(
    [
      "Hola,",
      "",
      "Me gustaría hablar sobre los planes para mi organización.",
      "",
      `Org: ${orgName || orgId}`,
      email ? `Email: ${email}` : "",
      "",
      "Gracias.",
    ]
      .filter(Boolean)
      .join("\n"),
  );

  return (
    <section className="space-y-8">
      <div className="space-y-3">
        <p className="text-sm font-semibold uppercase tracking-wider text-ink-3">
          Paso 3 · Planes
        </p>
        <h1 className="text-4xl sm:text-6xl font-black tracking-tight text-ink leading-[1.05]">
          Elige tu plan
          <br />
          cuando estés listo.
        </h1>
        <p className="text-base sm:text-lg text-ink-2 max-w-2xl">
          Asignamos planes a medida según tu uso. Puedes empezar sin plan y
          avisarnos cuando lo necesites — también aceptamos pagos únicos por
          proyecto.
        </p>
      </div>

      <PlansShowcase
        readOnly
        currentTierSlug={currentTierSlug}
        contactContext={{ orgId, orgName, email }}
      />

      <div className="flex flex-wrap items-center gap-4 pt-2">
        <button
          type="button"
          onClick={onContinue}
          className="inline-flex items-center gap-2 bg-ink text-white text-base font-semibold px-6 py-3 rounded-full transition-all duration-200 hover:scale-[1.02]"
        >
          Saltar por ahora
          <ArrowRight className="w-4 h-4" />
        </button>
        <a
          href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`}
          className="text-sm font-semibold text-ink underline-offset-4 hover:underline"
        >
          Hablar con nosotros
        </a>
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1 text-sm text-ink-2 hover:text-ink transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Atrás
        </button>
      </div>
    </section>
  );
}
